<template>
  <div :class="isSushi && 'montserrat-500  background-sushi-blue '">

    <sushi-nav v-if="isSushi" />
    <header v-if="!(isWC() && !isMobile())" :style="style">
      <overlay :isActive="showOverlay" @closed="showOverlay = false"></overlay>
      <top-menu @open-overlay="showOverlay = true" />
    </header>

    <div v-if="!isWC()" :class="!isSushi? headAbsolute != '' ?'head headersize':'head headersize-noimage' : 'introImgSushi headerSizeSushi'" :style="{ 'background-image': isSushi ? sushiImg :  headAbsolute }" />
    <section class="container">
      <slot />
    </section>

    <terms-and-condition v-if="isSushi" />
    <page-footer v-else />
  </div>
</template>
<script>
import TopMenu from "./../shared/TopMenu.vue";
import PageFooter from "./../shared/footer.vue";
import overlay from "./overlay.vue";
import { mapGetters } from "vuex";
import SushiNav from "@/components/sushiHub/sushiNav";
import TermsAndCondition from "@/components/sushiHub/termsAndCondition";
export default {
  components: {
    TermsAndCondition,
    SushiNav,
    TopMenu,
    PageFooter,
    overlay
  },
  data() {
    return {
      style: {
        "min-height": this.isWC() ? "80px" : "0"
      },
      showOverlay: false
    };
  },
  computed: {
    ...mapGetters(["hqDoc"]),
    headAbsolute() {
      if (this.hqDoc) {
        return `url(${this.hqDoc.ProfileImage})`;
      }
      return "";
    },
    sushiImg: require("../../assets/images/sushiHub/homeBanner.png"),
    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  }
};
</script>
